import type { Conversation } from '../lib/matrix/rooms.js';

// Cor estável por pessoa, derivada do @usuário: vira o tom suave atrás das
// iniciais de quem não tem foto. Grupo fica no neutro, com o ícone de grupo.
const PEOPLE: string[] = [
  '#8D5EB7',
  '#E15F8E',
  '#E1A100',
  '#0E9F6E',
  '#3A5BC7',
  '#7C3AED',
  '#0891B2',
  '#2563EB',
];

/**
 * `group` diz se é grupo (ícone de duas pessoas no lugar das iniciais) e
 * `badge`, que selo desenhar na miniatura: grupo, conversa protegida ou nenhum.
 */
export function conversationAvatar(c: Conversation): {
  c: string;
  group: boolean;
  badge: 'group' | 'lock' | null;
} {
  if (!c.isDirect) return { c: '#8B5CF6', group: true, badge: 'group' };
  const key = c.otherUserId ?? c.roomId;
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  const color = PEOPLE[h % PEOPLE.length] ?? PEOPLE[0]!;
  return { c: color, group: false, badge: c.encrypted ? 'lock' : null };
}
